import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

/**
 * ACE-style course card: title + short blurb + hover lift.
 */
const TrainingCourseCard = ({ course, index = 0, variant = "featured" }) => {
  const Icon = course.icon;

  if (variant !== "featured") {
    return null;
  }

  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: index * 0.05 }}
      whileHover={{ y: -8 }}
      className="group flex flex-col h-full bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl hover:border-[var(--bg-primary)]/25 transition-all duration-300 overflow-hidden"
    >
      <div className="h-1.5 w-full bg-gradient-to-r from-[var(--bg-primary)] to-[#F86624] opacity-80 group-hover:opacity-100 transition-opacity" />
      <div className="p-6 md:p-7 flex flex-col flex-1">
        <div className="w-12 h-12 rounded-xl bg-[var(--bg-primary)]/10 flex items-center justify-center mb-5 group-hover:bg-[var(--bg-primary)] transition-colors duration-300">
          {Icon && (
            <Icon
              size={22}
              className="text-[var(--bg-primary)] group-hover:text-white transition-colors duration-300"
              aria-hidden="true"
            />
          )}
        </div>
        <span className="text-xs font-semibold uppercase tracking-wide text-[#F86624] mb-2">
          {course.category}
        </span>
        <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 group-hover:text-[var(--bg-primary)] transition-colors leading-snug">
          {course.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-6">
          {course.description}
        </p>
        <Link
          to={course.link}
          className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--bg-primary)] hover:text-[#F86624] transition-colors mt-auto"
        >
          {course.cta || "Learn More"}
          <FiArrowRight size={16} aria-hidden="true" />
        </Link>
      </div>
    </motion.article>
  );
};

export default TrainingCourseCard;
